(function () {
  function controlsStripHeight(video) {
    var rect = video.getBoundingClientRect();
    if (rect.height < 1) return 56;
    return Math.max(48, Math.min(80, rect.height * 0.22));
  }

  function clickIsOnNativeControls(video, clientY) {
    var rect = video.getBoundingClientRect();
    return clientY > rect.bottom - controlsStripHeight(video);
  }

  function initMulticolumnVideoRoot(multicolumnRoot) {
    if (multicolumnRoot.getAttribute('data-multicolumn-video-initialized') === 'true') return;
    multicolumnRoot.setAttribute('data-multicolumn-video-initialized', 'true');

    var sectionId = multicolumnRoot.getAttribute('data-section-id');
    if (!sectionId) return;

    var modal = document.getElementById('multicolumn-video-modal-' + sectionId);
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var multicolumnVideoLastActivate = 0;

    function closeModal() {
      if (!modal) return;
      var slot = modal.querySelector('.multicolumn-video__modal-slot');
      var video = slot ? slot.querySelector('video.pip-video') : null;
      var wrap = modal._multicolumnActiveWrap;
      if (video) {
        video.removeAttribute('controls');
        video.muted = true;
        video.currentTime = 0;
        if (wrap) wrap.appendChild(video);
        video.play().catch(function () {});
      }
      modal.classList.add('multicolumn-video__modal--hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('multicolumn-video-modal-open');
      modal._multicolumnActiveWrap = null;
    }

    function openModal(wrap) {
      if (!modal || !wrap) return;
      var video = wrap.querySelector('video.pip-video');
      if (!video) return;
      closeModal();
      var slot = modal.querySelector('.multicolumn-video__modal-slot');
      if (!slot) return;
      slot.appendChild(video);
      modal._multicolumnActiveWrap = wrap;
      video.setAttribute('controls', '');
      video.muted = false;
      modal.classList.remove('multicolumn-video__modal--hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('multicolumn-video-modal-open');
      requestAnimationFrame(function () {
        video.play().catch(function () {});
        if (window.matchMedia('(pointer: fine)').matches) {
          var closeBtn = modal.querySelector('.multicolumn-video__modal-close');
          if (closeBtn) closeBtn.focus();
        }
      });
    }

    function tryOpenVideoModal(wrap, video, clientY, sourceEvent) {
      if (multicolumnRoot._multicolumnVideoDidDrag) return;
      if (video.closest('.multicolumn-video__modal')) {
        if (clickIsOnNativeControls(video, clientY)) return;
        return;
      }
      if (clickIsOnNativeControls(video, clientY)) return;
      var now = Date.now();
      if (now - multicolumnVideoLastActivate < 450) return;
      if (!wrap.querySelector('video.pip-video')) return;
      if (sourceEvent) {
        sourceEvent.preventDefault();
        sourceEvent.stopPropagation();
      }
      multicolumnVideoLastActivate = now;
      openModal(wrap);
    }

    if (multicolumnRoot && modal) {
      var MOVE_SLOP_SQ = 12 * 12;

      multicolumnRoot.querySelectorAll('[data-multicolumn-video-wrap]').forEach(function (wrap) {
        var video = wrap.querySelector('video.pip-video');
        if (!video) return;

        wrap.setAttribute('role', 'button');
        wrap.setAttribute('tabindex', '0');
        wrap.setAttribute('aria-label', video.getAttribute('aria-label') || 'Play video');

        var gesture = {
          tracking: false,
          startX: 0,
          startY: 0,
          slopExceeded: false,
          suppressClick: false,
        };

        video.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            gesture.tracking = true;
            gesture.startX = e.clientX;
            gesture.startY = e.clientY;
            gesture.slopExceeded = false;
            gesture.suppressClick = false;
          },
          { passive: true }
        );

        video.addEventListener(
          'pointermove',
          function (e) {
            if (!gesture.tracking) return;
            var dx = e.clientX - gesture.startX;
            var dy = e.clientY - gesture.startY;
            if (dx * dx + dy * dy > MOVE_SLOP_SQ) {
              gesture.slopExceeded = true;
            }
          },
          { passive: true }
        );

        video.addEventListener(
          'pointercancel',
          function () {
            if (!gesture.tracking) return;
            gesture.tracking = false;
            gesture.suppressClick = true;
          },
          { passive: true }
        );

        video.addEventListener(
          'pointerup',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (!gesture.tracking) return;
            gesture.tracking = false;
            if (gesture.slopExceeded) {
              gesture.suppressClick = true;
              return;
            }
            tryOpenVideoModal(wrap, video, e.clientY, e);
          },
          { passive: false }
        );

        video.addEventListener('click', function (e) {
          if (gesture.suppressClick) {
            e.preventDefault();
            e.stopPropagation();
            gesture.suppressClick = false;
            return;
          }
          if (Date.now() - multicolumnVideoLastActivate < 400) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          tryOpenVideoModal(wrap, video, e.clientY, e);
        });

        wrap.addEventListener('click', function (e) {
          if (e.target !== wrap) return;
          tryOpenVideoModal(wrap, video, e.clientY, e);
        });

        wrap.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          tryOpenVideoModal(wrap, video, 0, e);
        });
      });

      function bindModalClose(el) {
        el.addEventListener(
          'pointerup',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
          },
          { passive: false }
        );
        el.addEventListener(
          'touchend',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
          },
          { passive: false }
        );
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
        });
      }

      modal.querySelectorAll('[data-multicolumn-video-close]').forEach(bindModalClose);

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (modal.classList.contains('multicolumn-video__modal--hidden')) return;
        closeModal();
      });
    }

    var slider = multicolumnRoot.querySelector('#Slider-' + sectionId);
    var sliderHost = slider ? slider.closest('slider-component') : null;
    var prevButton = sliderHost ? sliderHost.querySelector('.slider-button--prev') : null;
    var nextButton = sliderHost ? sliderHost.querySelector('.slider-button--next') : null;
    var dotsContainer = multicolumnRoot.querySelector('[data-multicolumn-video-dots]');

    if (slider) {
      var currentSlide = 0;
      var slides = Array.from(slider.children);
      var totalSlides = slides.length;
      var dotButtons = [];
      var maxSlide = 0;
      var scrollSyncFrame = null;
      var isSliderDragging = false;

      slider.style.transform = '';

      function getVisibleSlideCount() {
        if (!slides[0]) return 1;
        var slideWidth = slides[0].offsetWidth;
        var gap = parseFloat(window.getComputedStyle(slider).gap) || 0;
        if (slideWidth <= 0) return 1;
        return slider.clientWidth / (slideWidth + gap);
      }

      function computeMaxSlide() {
        if (slides.length <= 1) return 0;
        var visibleCount = getVisibleSlideCount();
        return Math.max(0, slides.length - Math.max(1, Math.floor(visibleCount)));
      }

      function getClosestSlideIndex() {
        var scrollLeft = slider.scrollLeft;
        var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
        var closest = 0;
        var minDistance = Infinity;

        for (var i = 0; i <= maxSlide; i++) {
          var targetScroll = Math.min(slides[i].offsetLeft, maxScroll);
          var distance = Math.abs(targetScroll - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            closest = i;
          }
        }

        return closest;
      }

      function updateDots() {
        dotButtons.forEach(function (dot, index) {
          var isActive = index === currentSlide;
          dot.classList.toggle('multicolumn-video__dot--active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function updateButtons() {
        if (!prevButton || !nextButton) return;
        prevButton.style.opacity = currentSlide === 0 ? '0.5' : '1';
        nextButton.style.opacity = currentSlide >= maxSlide ? '0.5' : '1';
        prevButton.disabled = currentSlide === 0;
        nextButton.disabled = currentSlide >= maxSlide;
      }

      function goToSlide(index, behavior) {
        currentSlide = Math.max(0, Math.min(index, maxSlide));
        var target = slides[currentSlide];
        if (!target) return;

        var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
        slider.scrollTo({
          left: Math.min(target.offsetLeft, maxScroll),
          behavior: behavior || 'smooth',
        });

        updateButtons();
        updateDots();
      }

      function syncFromScroll() {
        currentSlide = getClosestSlideIndex();
        updateButtons();
        updateDots();
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        dotButtons = [];

        var dotsCount = maxSlide + 1;
        for (var i = 0; i < dotsCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'multicolumn-video__dot' + (i === currentSlide ? ' multicolumn-video__dot--active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.setAttribute('aria-selected', i === currentSlide ? 'true' : 'false');
          dot.addEventListener('click', function (index) {
            return function () {
              goToSlide(index);
            };
          }(i));
          dotsContainer.appendChild(dot);
          dotButtons.push(dot);
        }
      }

      function refreshSliderState() {
        maxSlide = computeMaxSlide();
        if (currentSlide > maxSlide) {
          currentSlide = maxSlide;
        }
        buildDots();
        goToSlide(currentSlide, 'auto');
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (currentSlide < maxSlide) {
            goToSlide(currentSlide + 1);
          }
        });
      }

      slider.addEventListener(
        'scroll',
        function () {
          if (isSliderDragging) return;
          if (scrollSyncFrame) return;
          scrollSyncFrame = window.requestAnimationFrame(function () {
            scrollSyncFrame = null;
            syncFromScroll();
          });
        },
        { passive: true }
      );

      function addDesktopDrag() {
        var isDragging = false;
        var startX = 0;
        var scrollLeftStart = 0;
        var dragDelta = 0;
        var hasDragged = false;
        var dragFrame = null;
        var pausedVideos = [];

        function isDesktopDragEnabled() {
          return window.matchMedia('(min-width: 750px) and (pointer: fine)').matches;
        }

        function pauseVideosForDrag() {
          pausedVideos = [];
          slides.forEach(function (slide) {
            var video = slide.querySelector('video.pip-video');
            if (video && !video.paused) {
              pausedVideos.push(video);
              video.pause();
            }
          });
        }

        function resumeVideosAfterDrag() {
          pausedVideos.forEach(function (video) {
            video.play().catch(function () {});
          });
          pausedVideos = [];
        }

        function applyDragPosition() {
          if (!isDragging) return;
          slider.scrollLeft = scrollLeftStart - dragDelta;
          dragFrame = window.requestAnimationFrame(applyDragPosition);
        }

        function onMouseDown(e) {
          if (!isDesktopDragEnabled()) return;
          if (e.button !== 0) return;

          isDragging = true;
          isSliderDragging = true;
          hasDragged = false;
          dragDelta = 0;
          startX = e.pageX;
          scrollLeftStart = slider.scrollLeft;
          slider.classList.add('multicolumn-video-slider__track--dragging');
          pauseVideosForDrag();
          dragFrame = window.requestAnimationFrame(applyDragPosition);
        }

        function onMouseMove(e) {
          if (!isDragging || !isDesktopDragEnabled()) return;

          dragDelta = e.pageX - startX;
          if (Math.abs(dragDelta) > 3) {
            hasDragged = true;
          }

          if (hasDragged) {
            e.preventDefault();
          }
        }

        function endDrag() {
          if (!isDragging) return;

          isDragging = false;
          isSliderDragging = false;

          if (dragFrame) {
            window.cancelAnimationFrame(dragFrame);
            dragFrame = null;
          }

          slider.classList.remove('multicolumn-video-slider__track--dragging');
          resumeVideosAfterDrag();

          if (hasDragged) {
            multicolumnRoot._multicolumnVideoDidDrag = true;
            goToSlide(getClosestSlideIndex(), 'smooth');
            window.setTimeout(function () {
              multicolumnRoot._multicolumnVideoDidDrag = false;
            }, 150);
          } else {
            syncFromScroll();
          }
        }

        slider.addEventListener('mousedown', onMouseDown);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', endDrag);

        slider.addEventListener(
          'click',
          function (e) {
            if (multicolumnRoot._multicolumnVideoDidDrag) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
      }

      addDesktopDrag();

      refreshSliderState();

      window.addEventListener('resize', function () {
        refreshSliderState();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-multicolumn-video-root]').forEach(initMulticolumnVideoRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
